<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="successPage">
            <div class="bannerArea">
                <div class="bannerBox">
                    <div class="titleBox">
                        <span>{{ 'solutions.success.title' | translate }}</span>
                        <h1>
                            {{
                                'solutions.explore.successCases.' +
                                    getSuccessKeyFromNameEN(fullPiece?.NameEN) +
                                    '.name' | translate
                            }}
                        </h1>
                    </div>
                    <p class="meta">
                        <span class="date">{{ fullPiece?.Date }}</span>
                        <!-- <span class="bar">｜</span>
                        <span class="main">
                            {{
                                getTranslatedTypeParts(
                                    fullPiece?.NameEN,
                                    'before'
                                )
                            }}</span
                        >
                        <ng-container
                            *ngFor="
                                let tag of getTranslatedTypeParts(
                                    fullPiece?.NameEN,
                                    'after'
                                )
                            ">
                            <span class="bar">｜</span>
                            <span class="tag">{{ tag }}</span>
                        </ng-container> -->
                    </p>
                </div>
            </div>

            <div class="briefArea">
                <div class="briefBox">
                    <h2>
                        {{ 'solutions.success.sections.brief' | translate }}
                    </h2>
                    <p>
                        {{
                            'solutions.explore.successCases.' +
                                getSuccessKeyFromNameEN(fullPiece?.NameEN) +
                                '.brief' | translate
                        }}
                    </p>
                </div>
            </div>

            <div class="painArea">
                <div class="painBox">
                    <div class="problemBox">
                        <h2>
                            {{
                                'solutions.success.sections.problem' | translate
                            }}
                        </h2>
                        <p>
                            {{
                                'solutions.explore.successCases.' +
                                    getSuccessKeyFromNameEN(fullPiece?.NameEN) +
                                    '.pain.problem.intro' | translate
                            }}
                        </p>
                        <ol>
                            <li *ngFor="let li of getPainDescList('problem')">
                                {{ li }}
                            </li>
                        </ol>
                    </div>
                    <div class="challengeBox">
                        <h2>
                            {{
                                'solutions.success.sections.challenge'
                                    | translate
                            }}
                        </h2>
                        <ol>
                            <li *ngFor="let li of getPainDescList('challenge')">
                                {{ li }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="applyArea">
                <div class="applyBox">
                    <h2>
                        {{ 'solutions.success.sections.apply' | translate }}
                    </h2>
                    <p>
                        {{
                            'solutions.explore.successCases.' +
                                getSuccessKeyFromNameEN(fullPiece?.NameEN) +
                                '.apply.intro' | translate
                        }}
                    </p>
                    <ol>
                        <li
                            *ngFor="
                                let li of fullPiece?.Apply?.DescList;
                                let i = index
                            ">
                            <span class="gist">{{
                                'solutions.explore.successCases.' +
                                    getSuccessKeyFromNameEN(fullPiece?.NameEN) +
                                    '.apply.descList.' +
                                    i +
                                    '.title' | translate
                            }}</span>
                            <p class="desc">
                                {{
                                    'solutions.explore.successCases.' +
                                        getSuccessKeyFromNameEN(
                                            fullPiece?.NameEN
                                        ) +
                                        '.apply.descList.' +
                                        i +
                                        '.desc' | translate
                                }}
                            </p>
                        </li>
                    </ol>
                    <p>
                        {{
                            'solutions.explore.successCases.' +
                                getSuccessKeyFromNameEN(fullPiece?.NameEN) +
                                '.apply.outro' | translate
                        }}
                    </p>
                </div>
            </div>

            <div class="resultArea">
                <div class="resultBox">
                    <div class="halfBox">
                        <img
                            src="/assets/images/success/result-small.png"
                            alt="" />
                        <h2>
                            {{
                                'solutions.success.sections.result' | translate
                            }}
                        </h2>
                        <p
                            [innerHTML]="
                                'solutions.explore.successCases.' +
                                    getSuccessKeyFromNameEN(fullPiece?.NameEN) +
                                    '.result' | translate
                            "></p>
                    </div>
                </div>
            </div>

            <!-- <div
                class="relatedArea"
                *ngIf="this.relatedNews.length"
            >
				<div class="relatedBox">
					<h3>點擊前往相關新聞</h3>
					<div
						class="infoCard"
						(click)="goViewNews(relatedNews[0]?.TypeEN, relatedNews[0]?.FileTitle)"
					>
						<h4>
							{{ relatedNews[0]?.Content }}
						</h4>
						<p>{{ relatedNews[0]?.Date }}</p>
					</div>
				</div>
			</div> -->

            <div class="moreArea">
                <div class="moreBox">
                    <div class="prompt">
                        <h2>
                            {{
                                'solutions.success.navigation.more'
                                    | translate
                                        : {
                                              type: getTranslatedTypeParts(
                                                  fullPiece?.NameEN,
                                                  'before'
                                              )
                                          }
                            }}
                        </h2>
                        <p>
                            {{
                                'solutions.success.navigation.find'
                                    | translate
                                        : {
                                              category:
                                                  ('solutions.explore.successCases.' +
                                                      getSuccessKeyFromNameEN(
                                                          fullPiece?.NameEN
                                                      ) +
                                                      '.mainCategory'
                                                  | translate)
                                          }
                            }}
                        </p>
                        &nbsp;
                        <a
                            [routerLink]="
                                goExploreMoreSolutions(fullPiece?.MainCategory)
                            "
                            [title]="
                                '前往' + fullPiece?.MainCategory + '解決方案'
                            ">
                            {{
                                'solutions.success.navigation.goToLink'
                                    | translate
                            }}
                        </a>
                    </div>

                    <div
                        class="swiperBox"
                        *ngIf="showSwiper">
                        <swiper
                            [slidesPerView]="perPage"
                            [spaceBetween]="32"
                            [speed]="200"
                            [scrollbar]="{
                                el: '.swiper-scrollbar',
                                hide: false
                            }"
                            [navigation]="{
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev'
                            }"
                            [observeParents]="true">
                            <ng-container
                                *ngFor="
                                    let topic of relatedPieces;
                                    let index = index
                                ">
                                <ng-template swiperSlide>
                                    <div
                                        class="info-card"
                                        [ngClass]="{
                                            'info-card': true,
                                            'info-card-even': index % 2 === 0,
                                            'info-card-odd': index % 2 !== 0
                                        }"
                                        (click)="goToSuccess(topic?.NameEN)">
                                        <div class="vital">
                                            <p class="date">
                                                {{ topic?.Date }}
                                            </p>
                                            <p class="type">
                                                <span>
                                                    {{
                                                        getTranslatedTypeParts(
                                                            topic?.NameEN,
                                                            'before'
                                                        )
                                                    }}
                                                </span>
                                                ｜
                                                {{
                                                    getTranslatedTypeParts(
                                                        topic?.NameEN,
                                                        'after'
                                                    )
                                                }}
                                            </p>
                                            <h3 class="content">
                                                {{
                                                    'solutions.explore.successCases.' +
                                                        getSuccessKeyFromNameEN(
                                                            topic?.NameEN
                                                        ) +
                                                        '.name' | translate
                                                }}
                                            </h3>
                                            <div class="tagBox">
                                                <p>
                                                    {{ ('solutions.explore.successCases.' + getSuccessKeyFromNameEN(topic?.NameEN) + '.tags' | translate)?.join?.('，') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>
                        </swiper>
                        <div
                            class="swiper-btm"
                            [ngStyle]="
                                this.relatedPieces.length > this.perPage
                                    ? { display: 'flex' }
                                    : { display: 'none' }
                            ">
                            <div class="scroll">
                                <div class="swiper-scrollbar"></div>
                            </div>
                            <div class="action">
                                <button
                                    class="swiper-button-prev"
                                    aria-label="前一頁"></button>
                                {{ swiperPageRef }}
                                <button
                                    class="swiper-button-next"
                                    aria-label="下一頁"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-partnership></app-partnership>
        </div>
    </div>
</div>
<app-footer></app-footer>
